import { Component, Input } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { each, find } from 'lodash';

import { RecordField } from '../record/record';


@Component({
  selector: 't-execution-form',
  templateUrl: './execution-form.component.html',
})
export class ExecutionFormComponent {
  
  @Input()
  fields: RecordField[]

  booleanOptions = [
    {
      value: 'Oui',
      text: 'Oui'
    },
    {
      value: '',
      text: 'Non'
    }
  ];

  constructor(private builder: FormBuilder) { }
}